import { render, staticRenderFns } from "./GuestsOptions.vue?vue&type=template&id=04feb1d0&scoped=true"
import script from "./GuestsOptions.vue?vue&type=script&lang=js"
export * from "./GuestsOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04feb1d0",
  null
  
)

export default component.exports